import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-form" }
const _hoisted_3 = { class: "modal-head" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Le propriétaire répondra directement à vos questions", -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "left"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  class: "title",
  style: {"font-size":"1.2em"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, " Questions fréquentes : ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ul", { style: {} }, [
  /*#__PURE__*/_createElementVNode("li", null, " L'assurance est-elle comprise ? "),
  /*#__PURE__*/_createElementVNode("li", null, " Y-a-t-il une caution ou autre chose en plus du loyer ? "),
  /*#__PURE__*/_createElementVNode("li", null, " Comment les locaux sont-ils surveillés ? "),
  /*#__PURE__*/_createElementVNode("li", null, " Pouver-vous m'aider à définir la bonne taille de box ? "),
  /*#__PURE__*/_createElementVNode("li", null, " Peut-on venir visiter quand on veut ? "),
  /*#__PURE__*/_createElementVNode("li", null, " Y-a-t-il du matériel de manutention ? "),
  /*#__PURE__*/_createElementVNode("li", null, " Est-ce que le box de X m² est disponible ? ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "endtitle" }, " * : Champs obligatoires ", -1)
const _hoisted_12 = { class: "right" }
const _hoisted_13 = {
  key: 0,
  class: "modal-body-top"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Une question à poser au propriétaire ? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" N'hésitez plus ! ")
], -1)
const _hoisted_15 = {
  key: 0,
  class: "loading"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "Traitement de la demande...", -1)
const _hoisted_17 = {
  key: 1,
  class: "success"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "Demande traitée avec succès !", -1)
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "question_name" }, "Nom *", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "question_surname" }, "Prénom *", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "question_email" }, "E-mail *", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "question_phone" }, "Téléphone *", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "question_message" }, "Votre message pour le propriétaire du garde meuble *", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "question_approx_date" }, "Date de location souhaitée", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "question_approx_size" }, "Taille approximative de box", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: "Aucune taille sélectionnée"
}, " Choisissez une taille ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "1m² à 2m²" }, " 1m² à 2m² ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "2m² à 4m²" }, " 2m² à 4m² ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "4m² à 6m²" }, " 4m² à 6m² ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "6m² à 10m²" }, " 6m² à 10m² ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "10m² à 15m²" }, " 10m² à 15m² ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "15m² ou plus²" }, " 15m² ou plus ", -1)
const _hoisted_34 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button",
  name: "question_submit"
}, " Envoyer ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_font_awesome_icon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => {this.store.state.contact_modal = false;}),
          icon: "times"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (this.store.getters.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("img", {
                src: this.store.state.gm.images[0].url,
                alt: this.store.state.gm.images[0].title,
                width: "320",
                height: "180"
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, _toDisplayString(this.store.state.gm.name), 1),
              _hoisted_9,
              _hoisted_10,
              _hoisted_11
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          (!this.loading && !this.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createVNode(_component_font_awesome_icon, { icon: "comment-dots" })
                ]),
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (this.submit()), ["prevent"]))
          }, [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (this.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_font_awesome_icon, {
                          icon: "spinner",
                          pulse: ""
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (this.success)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_font_awesome_icon, { icon: "check-circle" }),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.store.state.contact_modal = false)),
                          class: "button"
                        }, " Revenir au garde-meuble ")
                      ]))
                    : _createCommentVNode("", true),
                  (!this.loading && !this.success)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _hoisted_20,
                            _withDirectives(_createElementVNode("input", {
                              required: "",
                              type: "text",
                              name: "question_name",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.question_name) = $event)),
                              id: "question_name",
                              placeholder: "Entrer votre nom"
                            }, null, 512), [
                              [_vModelText, this.question_name]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_21,
                            _withDirectives(_createElementVNode("input", {
                              required: "",
                              type: "text",
                              name: "question_surname",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.question_surname) = $event)),
                              id: "question_surname",
                              placeholder: "Entrer votre prénom"
                            }, null, 512), [
                              [_vModelText, this.question_surname]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _hoisted_22,
                            _withDirectives(_createElementVNode("input", {
                              required: "",
                              type: "email",
                              name: "question_email",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.question_email) = $event)),
                              id: "question_email",
                              placeholder: "Entrer votre email"
                            }, null, 512), [
                              [_vModelText, this.question_email]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_23,
                            _withDirectives(_createElementVNode("input", {
                              required: "",
                              type: "text",
                              name: "question_phone",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.question_phone) = $event)),
                              id: "question_phone",
                              placeholder: "Entrer votre téléphone"
                            }, null, 512), [
                              [_vModelText, this.question_phone]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _hoisted_24,
                            _withDirectives(_createElementVNode("textarea", {
                              required: "",
                              name: "question_message",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.question_message) = $event)),
                              id: "question_message",
                              rows: "10",
                              placeholder: "Entrer votre message"
                            }, null, 512), [
                              [_vModelText, this.question_message]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _hoisted_25,
                            _withDirectives(_createElementVNode("input", {
                              required: "",
                              type: "date",
                              name: "question_approx_date",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.question_approx_date) = $event)),
                              id: "question_approx_date",
                              placeholder: "Choisir une date de location"
                            }, null, 512), [
                              [_vModelText, this.question_approx_date]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_26,
                            _withDirectives(_createElementVNode("select", {
                              required: "",
                              id: "question_approx_size",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.question_approx_size) = $event)),
                              name: "question_approx_size"
                            }, _hoisted_34, 512), [
                              [_vModelSelect, this.question_approx_size]
                            ])
                          ])
                        ]),
                        (this.error && this.error.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(this.error), 1))
                          : _createCommentVNode("", true),
                        _hoisted_36
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ], 32)
        ])
      ])
    ])
  ]))
}